export const searchFunction = <T>(
  searchText: string,
  items: T[],
  keys: (keyof T)[],
): T[] => {
  const normalizedSearchText = searchText.trim().toLowerCase();

  if (!normalizedSearchText) return items; // если поиск пустой — вернуть всё

  return items.filter((item) =>
    keys.some((key) => {
      const value = item[key];
      if (value === null || value === undefined) return false;
      return String(value).toLowerCase().includes(normalizedSearchText);
    }),
  );
};
